import { Button } from '@/components/ui/button';
import KeyboardKeyIcon from '@/components/ui/keyboard-key-icon';
import { PDKMenuIcon } from '@/components/ui/pdk-icons';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { HOTKEYS } from '@/lib/hotkeys';
import { cn } from '@/lib/utils';

const DealMenuButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button variant="ghost" className="p-1 h-fit" onClick={onClick}>
          <PDKMenuIcon className={cn('h-3.5 w-3.5 cursor-pointer', {})} />
        </Button>
      </TooltipTrigger>
      <TooltipContent className="flex flex-row gap-1 items-center">
        Deal Actions Menu
        <KeyboardKeyIcon>{HOTKEYS.DEAL_DEAL_MENU}</KeyboardKeyIcon>
      </TooltipContent>
    </Tooltip>
  );
};

export default DealMenuButton;
